import cloneDeep from 'lodash.clonedeep'
import { createRule } from './common'

export default lengths => {
  const errorMessageLengths = cloneDeep(lengths)

  if (lengths[0] === 0) {
    errorMessageLengths.splice(0, 1)
  }

  const errorMessage = `Field must contain either ${ errorMessageLengths.join(', ') } characters`

  const isValid = value => (
    value == null || lengths.some(len => value.toString().length === len)
  )

  return createRule({ isValid, errorMessage })
}
